import { gql } from '@apollo/client';

export const EXPORT_INSTITUTION = gql`
  fragment exportInstitution on Institution {
    id
    addressee
    allocation
    componentNumber
    districtMunicipality {
      id
      name
    }
    educatorNumber
    circuit {
      id
      name
    }
    region {
      id
      name
    }
    district {
      id
      name
    }
    emisNumber
    examCentre
    examNumber
    exDept
    facsimile
    gisAltitude
    gisLatitude
    gisLongitude
    gisSource
    learnerNumber
    location {
      id
      name
    }
    localMunicipality {
      id
      localMunicipality
    }
    name
    nas
    nodalArea
    noFeeSchool
    ownership
    ownerBuild
    ownerLand
    paypointNumber
    phase {
      id
      name
    }
    postalAddress
    province {
      id
      name
    }
    provinceCD
    quintile
    registrationDate
    section21
    section21Function
    sector {
      id
      name
    }
    specialization
    status
    streetAddress
    streetNo
    suburb
    townCity
    townshipVillage
    streetBuilding
    area
    type {
      id
      name
    }
    wardID
    wardLabel
    year
  }
`;
